module.exports = __webpack_public_path__ + "img/people-arrows.0771b23f.svg";